import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { brazilLinks, unitedStatesLinks } from '../../utils/login-links.utils';
import { getEnvironment } from '../environment';
import { CommunitiesEnvironments } from '../environment/models/communities-environments.enum';
import { LoginLinks } from './models/login-links.model';

@Component({
  selector: 'comm-links-footer',
  templateUrl: './links-footer.component.html',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinksFooterComponent {
  @Input() showBackToTownSq = true;
  @Input() showTermsOfUse = true;
  @Input() applyFixedFooterClass = true;
  @Input() loginSimplificationEnabled = false;
  @Input() showFullFooter: boolean;
  @Input() showRecoveryPassword: boolean;

  @Output() readonly goToUserRecoveryRoute = new EventEmitter<void>();

  protected readonly isTownSqBrazil = getEnvironment().env === CommunitiesEnvironments.BR_PROD;
  protected readonly loginLinks: LoginLinks = this.isTownSqBrazil ? brazilLinks : unitedStatesLinks;

  get supportContactTarget(): string | null {
    return this.loginLinks.supportContactLink.startsWith('mailto:') ? null : '_blank';
  }
}
